import React from 'react';

import { useGetEventAppearance, useLanguageByCodes } from '@api/hooks';
import { isAnyQueryFetching } from '@utils/query';
import { DEFAULT_LANGUAGE, NO_MARGIN_BOTTOM } from '@constants';
import { Form } from '@organisms';

import PageLocaleSelect from '../PageLocaleSelect';

const PageLanguageSelect = ({
  field,
  locale,
  onSelect,
  eventId,
  disabled,
  titleStyles,
  selectStyles,
  wrapperStyles,
  selectLanguageReloadContent,
}) => {
  const { appearance, ...appearanceQuery } = useGetEventAppearance({ id: eventId });
  const { languages: serverLanguages, ...languageQuery } = useLanguageByCodes({ codes: appearance?.languageCodes });
  const languages = serverLanguages.length ? serverLanguages : DEFAULT_LANGUAGE;

  const handleSelect = (selectValue) => {
    selectLanguageReloadContent(selectValue);
    // eslint-disable-next-line no-unused-expressions
    onSelect?.(selectValue);
  };

  const allQueries = [appearanceQuery, languageQuery];
  const isFetching = isAnyQueryFetching(allQueries);

  return (
    <Form.Item name={field.name} style={NO_MARGIN_BOTTOM}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        <PageLocaleSelect
          selectValue={locale}
          disabled={isFetching || disabled}
          loading={isFetching}
          onSelect={handleSelect}
          locales={languages}
          titleStyles={{
            marginRight: 10,
            marginBottom: 5,
            fontSize: 18,
            fontWeight: 'bolder',
            fontFamily: 'World Athletics',
            ...titleStyles,
          }}
          selectStyles={{ minWidth: 160, marginBottom: 0, ...selectStyles }}
          wrapperStyles={{ marginTop: 3, marginLeft: 0, ...wrapperStyles }}
        />
      </div>
    </Form.Item>
  );
};

export default PageLanguageSelect;
